import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c === 0 ? total - 1 : c - 1));
  const next = () => setCurrent((c) => (c === total - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            学员真实评价
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            来自已毕业学员的真实反馈，他们的改变就是我们最大的动力
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10 text-center">
            <div className="flex items-center justify-center gap-0.5 mb-5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
              ))}
            </div>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
              "{t.content}"
            </p>
            <div className="flex items-center justify-center gap-3">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="text-left">
                <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                <div className="text-xs text-foreground-500">{t.position}</div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-6">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
              aria-label="上一条"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <div className="flex items-center gap-1.5">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    i === current ? 'w-6 bg-primary-500' : 'bg-background-300'
                  }`}
                  aria-label={`第${i + 1}条评价`}
                />
              ))}
            </div>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
              aria-label="下一条"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}